import * as constants from '.'
import { RootState } from '../types'

export const getCurrentVariant = (state: RootState) =>
  state.experiment.variant || constants.CONTROL



// WEBPACK FOOTER //
// ./src/state/experiment/selectors.ts